module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"price":{"label":"Amount","placeholder":"0"},"cancel":"Cancel","save":"Save"}}')
  delete Component.options._Ctor
}
